import { render, staticRenderFns } from "./Departures.vue?vue&type=template&id=4223bab2&scoped=true&"
import script from "./Departures.vue?vue&type=script&lang=js&"
export * from "./Departures.vue?vue&type=script&lang=js&"
import style0 from "./Departures.vue?vue&type=style&index=0&id=4223bab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223bab2",
  null
  
)

export default component.exports